// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1330":"e47b2ef3","2672":"989461ea","3043":"76894541","5374":"989461ea","8131":"000aaa69","8141":"28544c62","8335":"6fb8759a","8822":"40aad314","9201":"6fb8759a","9595":"28544c62"}[chunkId] + ".chunk.css";
};